import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { b2cPagesService } from '@clubmed/utils';
import { ToasterImmersive } from 'Components/frameworks/toaster-immersive/ToasterImmersive';
import { ICONS } from 'Components/utils/icon/icons';
import { usePageContext } from 'Context/PageContext';
import { useBlockInputDepartureDate } from 'Src/hooks/use-block-input-departure-date/useBlockInputDepartureDate';
import { t } from 'Src/i18n';
import { getCalendarLoading } from 'Store/calendar/calendar.selector';
import { getDepartureDate } from 'Store/trip-criteria/tripCriteria.selector';
export const ResortNotBookingToasterContainer = ({
  setIsVisible,
}: {
  setIsVisible?: (arg0: boolean) => void;
}) => {
  const { pageType, pageId } = usePageContext();
  const calendarIsLoading = useSelector<boolean>(getCalendarLoading);
  const { PAGE_TYPES } = b2cPagesService;
  const isAllowedPage = [PAGE_TYPES.RESORT, PAGE_TYPES.CRUISE].includes(pageType);
  const { blockInputDepartureDate } = useBlockInputDepartureDate(true);
  const departureDate = useSelector<string>(getDepartureDate);
  const [hasInitialDepartureDate, setHasInitialDepartureDate] = useState(!!departureDate);
  const title = t('priceRemote.errors.noAvailabilities');
  const displayToaster =
    hasInitialDepartureDate && isAllowedPage && blockInputDepartureDate && !calendarIsLoading;
  useEffect(() => {
    setIsVisible && setIsVisible(displayToaster);
  }, [displayToaster]);
  useEffect(() => {
    setHasInitialDepartureDate(!!departureDate);
  }, [pageId]);
  return displayToaster ? (
    <ToasterImmersive
      title={title}
      iconName={ICONS.WARNING}
      onClose={() => {
        setIsVisible && setIsVisible(false);
      }}
    />
  ) : null;
};
